import axios from "axios";
const apiInstance = axios.create({
  baseURL: "https://api.cidusa.net",
});
export const inspectorForm = async (data: any) => {
  try {
    const response = await apiInstance.post("/auth/contact-us", data);
    return response;
  } catch (error) {
    throw error;
  }
};
